import React, { useState } from 'react';

function Chats() {
  const [messages, setMessages] = useState([
    { id: 1, text: "Hey! How's it going?", sender: 'other' },
    { id: 2, text: "Hi! I'm doing great, thanks for asking!", sender: 'me' },
    { id: 3, text: "That's awesome! What have you been up to lately?", sender: 'other' },
    { id: 4, text: "Just working on some cool projects. How about you?", sender: 'me' },
    { id: 5, text: "Same here! Really enjoying the new features on Tyne.", sender: 'other' },
  ]);
  const [inputValue, setInputValue] = useState('');

  const handleSend = () => {
    if (inputValue.trim()) {
      setMessages([...messages, {
        id: messages.length + 1,
        text: inputValue,
        sender: 'me'
      }]);
      setInputValue('');

      // Simulate a response after a short delay
      setTimeout(() => {
        setMessages(prev => [...prev, {
          id: prev.length + 1,
          text: "That's interesting! Tell me more about it.",
          sender: 'other'
        }]);
      }, 1000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-header">
        <h2>Chat with Friend</h2>
      </div>

      <div className="chat-messages">
        {messages.map((message) => (
          <div key={message.id} className={`message ${message.sender === 'me' ? 'sent' : ''}`}>
            <div className="message-avatar"></div>
            <div className="message-content">{message.text}</div>
          </div>
        ))}
      </div>

      <div className="chat-input">
        <div className="input-container">
          <input
            type="text"
            placeholder="Type a message..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button className="send-button" onClick={handleSend}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Chats;
